

export function setshowDivsConditionsMetadonnes(e:any){
    return {
        type : "SET_showDivsConditionsMetadonnes",
        payload:e
    }
}
